/* Personalizer v3 pricing, cart payload and submit.
   CART CONTRACT v3 (docs/personalizer-line-item-properties-contract.md):
   ONE main cart line — the combo variant whose SKU encodes how many besties
   picked each type (BB-F{f}T{t}C{c}) — plus property-free upsell lines, in a
   single POST /cart/add.js {items:[...]}. The main line carries "Besties",
   one "Bestie i" per bestie ("Full Set · Blue" / "Tote · Pink" / "Charm"),
   the "YOUR PHOTO_k" URLs, "Notes" (trimmed, ≤500) when typed, and
   "_personalizer": "v3". Colours live ONLY in properties — no COLOR option. */
(function () {
  'use strict';

  /* Minimal Shopify money formatter: supports {{amount}} and
     {{amount_no_decimals}}, which covers this store's money_format. */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      return key === 'amount_no_decimals' ? amount.split('.')[0] : amount;
    });
  }

  function typeDef(config, key) {
    var found = null;
    (config.types || []).forEach(function (t) { if (t.key === key) found = t; });
    return found;
  }

  /* v3 combo-SKU knowledge, fixed by the contract (config.types stays the UI
     source for labels/badges/compareAt; these keys are the payload contract):
     slot = position of the type's count in BB-F{f}T{t}C{c};
     display = short name for the visible "Bestie i" property. */
  var COMBO_TYPES = {
    full: { slot: 0, display: 'Full Set' },
    tote: { slot: 1, display: 'Tote' },
    charm: { slot: 2, display: 'Charm' }
  };

  /* [f, t, c] counts for a bestie list, or null when any bestie has no/unknown
     type (unknown keys cannot be encoded into a combo SKU). */
  function comboCounts(besties) {
    var counts = [0, 0, 0];
    for (var i = 0; i < besties.length; i++) {
      var meta = COMBO_TYPES[besties[i].type];
      if (!meta) return null;
      counts[meta.slot]++;
    }
    return counts;
  }

  function variantBySku(config, sku) {
    var match = null;
    (config.variants || []).forEach(function (v) { if (v.sku === sku && !match) match = v; });
    return match;
  }

  /* THE variant for the whole order: combo SKU built from the type counts.
     Null when a type is missing/unknown or the product lacks that combo. */
  function comboVariantFor(config, besties) {
    var counts = comboCounts(besties);
    if (!counts) return null;
    return variantBySku(config, (config.skuPrefix || 'BB-') + 'F' + counts[0] + 'T' + counts[1] + 'C' + counts[2]);
  }

  /* oneBag mode: the order-level type decides the combo shape for n pets —
     full  = one tote + n dolls (F1 C n-1)
     tote  = the tote alone, names embroidered, price flat (T1)
     charm = n dolls, no bag (C n) */
  var ONE_BAG_COUNTS = {
    full: function (n) { return [1, 0, n - 1]; },
    tote: function () { return [0, 1, 0]; },
    charm: function (n) { return [0, 0, n]; }
  };

  /* oneBag SKU grammar on top of the combo scheme:
     - tote orders with 2-3 names append N{n} (each extra embroidery +$20)
     - the twin offer appends X2 (both sets, 2nd at 30% off => 1.7x price) */
  /* "count" mode (nursery mobiles): the product's EXISTING variants are one
     per unit count ("1 Pet" ... "6 Pets") — matched by the leading number in
     the variant title. No SKU grammar, no product restructure. */
  /* Second product option (e.g. the mobile's frame) lives in the variant title
     before the slash: "Square / 3 Pets". axisValue narrows the match to one
     side of that axis; without it any axis is accepted. */
  function axisOf(title) {
    var parts = String(title || '').split('/');
    return parts.length > 1 ? parts[0].trim() : '';
  }

  function countVariant(config, n, axisValue) {
    // The count can sit anywhere in the title — "Square / 3 Pets", "3 Pets",
    // "3 Dolls". Prefer an AVAILABLE variant so sold-out rows never win.
    var match = null;
    var fallback = null;
    (config.variants || []).forEach(function (v) {
      var m = /(\d+)\s*(pet|doll|sheep|piece|portrait)/i.exec(String(v.title || ''));
      if (!m || parseInt(m[1], 10) !== n) return;
      if (axisValue && axisOf(v.title) !== axisValue) return;
      if (!fallback) fallback = v;
      if (v.available && !match) match = v;
    });
    return match || fallback;
  }

  /* Distinct axis values in variant order, each with the counts it offers and
     whether it can be ordered at all (merchants mark dead options by putting
     "sold out" in the option value itself). */
  function axisValues(config) {
    var seen = {};
    var out = [];
    (config.variants || []).forEach(function (v) {
      var a = axisOf(v.title);
      if (!a) return;
      if (!seen[a]) {
        seen[a] = { name: a, counts: [], soldOut: /sold\s*out/i.test(a) };
        out.push(seen[a]);
      }
      var m = /(\d+)\s*(pet|doll|sheep|piece|portrait)/i.exec(String(v.title || ''));
      if (m && v.available) seen[a].counts.push(parseInt(m[1], 10));
    });
    out.forEach(function (a) { if (!a.counts.length) a.soldOut = true; });
    return out;
  }

  function oneBagComboVariant(config, orderType, n, twin) {
    var shape = ONE_BAG_COUNTS[orderType];
    if (!shape) return null;
    var c = shape(n);
    var sku = (config.skuPrefix || 'BB-') + 'F' + c[0] + 'T' + c[1] + 'C' + c[2];
    if (orderType === 'tote' && n > 1) sku += 'N' + n;
    if (twin) sku += 'X2';
    return variantBySku(config, sku);
  }

  /* Per-type display price = the solo combo (one bestie, this type only):
     combo prices are component sums, so BB-F1T0C0 IS the Full Set price. */
  function typePriceCents(config, typeKey) {
    var meta = COMBO_TYPES[typeKey];
    if (!meta) return 0;
    var counts = [0, 0, 0];
    counts[meta.slot] = 1;
    var v = variantBySku(config, (config.skuPrefix || 'BB-') + 'F' + counts[0] + 'T' + counts[1] + 'C' + counts[2]);
    return v ? v.price : 0;
  }

  /* Twin set = the SAME single variant at quantity 2; the store's automatic
     BXGY discount (buy 1 -> 2nd at 20% off) prices the 2nd set at checkout. */
  var TWIN_2ND_FACTOR = 0.8;

  /* Cart quantity for one upsell input: per-pet upsells (data-per-pet, e.g.
     wings & halo) count their selected pets — zero until the customer picks
     (the extras step blocks submit while a ticked per-pet add-on has no pet).
     Everything doubles with the twin set. Plain upsells are 1. */
  function upsellQty(ctx, input) {
    var twin = ctx.config.bagMode === 'oneBag' && ctx.state.twin ? 2 : 1;
    if (input.hasAttribute('data-per-pet')) {
      var n = ctx.state.besties.length;
      if (n <= 1) return 1 * twin; // one pet: the tick is the answer
      var handle = input.getAttribute('data-handle') || '';
      var sel = (ctx.state.upsellPets && ctx.state.upsellPets[handle]) || [];
      return sel.filter(function (i) { return i >= 0 && i < n; }).length * twin;
    }
    if (input.hasAttribute('data-photo-pick')) return photoPicks(ctx, input).length;
    if (input.hasAttribute('data-name-charm')) return nameCharmItems(ctx).length;
    // Plain upsells (preview service) cover the whole order once — they do
    // NOT double with the twin set.
    return 1;
  }

  /* The photos picked for a photo-pick add-on, as {url} in pick order. */
  function photoPicks(ctx, input) {
    var photos = ctx.photoGroup() ? ctx.photoGroup().getPhotos() : [];
    var handle = input.getAttribute('data-handle') || '';
    var sel = ((ctx.state.upsellPhotos || {})[handle] || []).filter(function (i) { return i >= 0 && i < photos.length; });
    return sel.map(function (i) { return photos[i]; });
  }

  function checkedUpsellCents(ctx) {
    var total = 0;
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked').forEach(function (input) {
      total += (parseInt(input.getAttribute('data-price'), 10) || 0) * upsellQty(ctx, input);
    });
    return total;
  }

  /* Checked upsells for the DISPLAYED totals only: counted once the Extras
     step has been reached (ctx.extrasReached, personalizer.js), so the bar
     shows besties-only pricing on earlier steps. The cart payload is NOT
     gated — buildItems always adds checked extras (incl. the pre-checked
     recommended one). */
  function displayUpsellCents(ctx) {
    var reached = ctx.extrasReached ? ctx.extrasReached() : true;
    return reached ? checkedUpsellCents(ctx) : 0;
  }

  /* Sum of chosen type prices + checked upsells (once Extras is reached).
     Combo prices are component sums, so this EQUALS the combo variant price —
     display only; Shopify computes the real total server-side.
     oneBag mode reads the combo variant price directly: its products may not
     carry solo-type variants (e.g. no standalone charm SKU) to sum from. */
  function baseTotalCents(ctx) {
    if (ctx.config.bagMode === 'count') {
      var cv = countVariant(ctx.config, ctx.state.besties.length, ctx.state.axis);
      return (cv ? cv.price : 0) + displayUpsellCents(ctx);
    }
    if (ctx.config.bagMode === 'oneBag') {
      var combo = oneBagComboVariant(ctx.config, ctx.state.orderType || 'full', ctx.state.besties.length, false);
      var base = combo ? combo.price : 0;
      // Twin = qty 2 of the same variant; the automatic BXGY discount takes
      // 30% off the 2nd at checkout, so the shown total mirrors that math.
      if (ctx.state.twin) base = base + Math.round(base * TWIN_2ND_FACTOR);
      return base + displayUpsellCents(ctx);
    }
    var total = 0;
    ctx.state.besties.forEach(function (b) {
      if (b.type) total += typePriceCents(ctx.config, b.type);
    });
    return total + displayUpsellCents(ctx);
  }

  /* Strike-through total: each discounted type re-priced at its compareAt
     ($138 per Full Set) + everything else at its normal price. Returns 0 when
     no picked type has a compareAt (bar hides the strike). Display only. */
  function baseCompareCents(ctx) {
    if (ctx.config.bagMode === 'count') {
      var cv = countVariant(ctx.config, ctx.state.besties.length, ctx.state.axis);
      var cc = cv ? cv.compare : 0;
      return cc && cc > cv.price ? cc + displayUpsellCents(ctx) : 0;
    }
    // oneBag: the Full Set strikes at bag-compareAt + dolls at solo price; the
    // twin set strikes at 2x the single-set reference (that IS the discount).
    if (ctx.config.bagMode === 'oneBag') {
      var ot = ctx.state.orderType || 'full';
      var n = ctx.state.besties.length;
      var fullDef = typeDef(ctx.config, 'full');
      var compareC = fullDef ? Math.round(parseFloat(fullDef.compareAt) * 100) || 0 : 0;
      var singleRef = ot === 'full' && compareC
        ? compareC + (n - 1) * typePriceCents(ctx.config, 'charm')
        : 0;
      if (ctx.state.twin) {
        var single = oneBagComboVariant(ctx.config, ot, n, false);
        var ref = singleRef || (single ? single.price : 0);
        return ref ? ref * 2 + displayUpsellCents(ctx) : 0;
      }
      if (!singleRef) return 0;
      return singleRef + displayUpsellCents(ctx);
    }
    var total = 0;
    var any = false;
    ctx.state.besties.forEach(function (b) {
      if (!b.type) return;
      var def = typeDef(ctx.config, b.type);
      var compare = def ? Math.round(parseFloat(def.compareAt) * 100) || 0 : 0;
      if (compare) any = true;
      total += compare || typePriceCents(ctx.config, b.type);
    });
    return any ? total + displayUpsellCents(ctx) : 0;
  }

  /* The name charms as the cart carries them: block capitals (that is how
     they are crocheted), one entry per charm, blanks dropped. */
  function nameCharmItems(ctx) {
    var max = (ctx.config.nameCharmUpsell && ctx.config.nameCharmUpsell.maxLetters) || 8;
    var items = (ctx.state.upsellNameCharm && ctx.state.upsellNameCharm.items) || [];
    return items.map(function (it) {
      return { name: String((it && it.name) || '').trim().toUpperCase().slice(0, max), colour: String((it && it.colour) || '') };
    }).filter(function (it) { return it.name; });
  }

  /* Shared payload tail: photos, notes, contract marker, upsell lines. */
  function finishItems(ctx, props, variant, mainQty, version) {
    var photos = ctx.photoGroup() ? ctx.photoGroup().getPhotos() : [];
    for (var k = 0; k < photos.length; k++) props['YOUR PHOTO_' + (k + 1)] = photos[k].url;
    // Read the LIVE textarea at submit: browser-restored form text (bfcache,
    // session restore) never fires 'input', so ctx.state.note can be stale.
    var notesEl = ctx.root.querySelector('[data-personalizer-notes]');
    var note = String((notesEl ? notesEl.value : ctx.state.note) || '').trim().slice(0, 500);
    if (note) props['Notes'] = note; // visible property — fulfillment reads it
    props['_personalizer'] = version || 'v3';

    // Per-pet upsells (wings & halo): WHICH pets is a main-line property so
    // fulfillment sees it next to the pet names; the upsell line itself stays
    // property-free per contract, its quantity = selected pets (x2 on twin).
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked[data-per-pet]').forEach(function (input) {
      var handle = input.getAttribute('data-handle') || '';
      var sel = ((ctx.state.upsellPets && ctx.state.upsellPets[handle]) || [])
        .filter(function (i) { return i >= 0 && i < ctx.state.besties.length; })
        .sort(function (a, b) { return a - b; });
      if (!sel.length) return;
      var unit = ctx.config.perPetChipLabel || ctx.config.unitLabel || 'Bestie';
      var who = sel.map(function (i) {
        var nm = String(ctx.state.besties[i].petName || '').trim();
        return unit + ' ' + (i + 1) + (nm ? ' (' + nm + ')' : '');
      }).join(', ');
      props[input.getAttribute('data-title') || 'Add-on'] = who;
    });

    // Note-style add-ons (wings on mobiles): the customer's "which pet" text
    // rides the main line so fulfillment sees it next to the photos.
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked[data-note-upsell]').forEach(function (input) {
      var handle = input.getAttribute('data-handle') || '';
      var note = String((ctx.state.upsellNotes && ctx.state.upsellNotes[handle]) || '').trim().slice(0, 120);
      if (note) props[input.getAttribute('data-title') || 'Add-on'] = note;
    });

    // Name charms: names + yarn colours ride the main line too, so the
    // workshop sees them next to the pet they hang beside.
    var nameCharms = nameCharmItems(ctx);
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked[data-name-charm]').forEach(function (input) {
      if (nameCharms.length) props[input.getAttribute('data-title') || 'Name charm'] = nameCharms.map(function (it) { return it.name + (it.colour ? ' · ' + it.colour : ''); }).join(', ');
    });
    // Photo-pick add-ons: how many photos, on the main line as a heads-up.
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked[data-photo-pick]').forEach(function (input) {
      var picks = photoPicks(ctx, input);
      if (picks.length) props[input.getAttribute('data-title') || 'Photo charm'] = picks.length + (picks.length === 1 ? ' photo' : ' photos');
    });

    var items = [{ id: variant.id, quantity: mainQty || 1, properties: props }];
    ctx.root.querySelectorAll('.personalizer__upsell-input:checked').forEach(function (input) {
      var variants = {};
      // name charms: one line per colour + name (same colour + same name merge)
      if (input.hasAttribute('data-name-charm')) {
        try { variants = JSON.parse(input.getAttribute('data-variants') || '{}'); } catch (e) { variants = {}; }
        var groups = {};
        nameCharms.forEach(function (it) {
          var v = variants[it.colour];
          var id = v && v.available ? v.id : parseInt(input.value, 10);
          var key = id + '|' + it.name;
          if (!groups[key]) groups[key] = { id: id, quantity: 0, properties: { 'Name on the charm': it.name } };
          groups[key].quantity += 1;
        });
        Object.keys(groups).forEach(function (k) { items.push(groups[k]); });
        return;
      }
      var qty = upsellQty(ctx, input);
      if (qty <= 0) return;
      var line = { id: parseInt(input.value, 10), quantity: qty }; // upsells: NO properties…
      // …except photo-pick add-ons: the chosen photos ride their own line so
      // the person printing them never hunts through the order.
      if (input.hasAttribute('data-photo-pick')) {
        var picks = photoPicks(ctx, input);
        line.properties = {};
        picks.forEach(function (p, k) { line.properties['YOUR PHOTO_' + (k + 1)] = p.url; });
      }
      items.push(line);
    });
    // Companion product last: it is a separate product with its own
    // personalization, so it carries its own properties (and stays BELOW the
    // personalized line in the cart, which the cart page relies on).
    var c = cross();
    if (c) {
      c.items().forEach(function (item) {
        // Offers made from the same photos carry them on their own line: the
        // person stitching the second piece must not have to hunt through the
        // order for the first one's attachments.
        var handle = item.offerHandle;
        delete item.offerHandle;
        if (handle && c.usesOrderPhotos(handle)) {
          // the offer may be for only some of the faces on this order
          var mine = c.orderPhotosFor ? c.orderPhotosFor(handle, photos) : photos;
          for (var pi = 0; pi < mine.length; pi++) {
            item.properties['YOUR PHOTO_' + (pi + 1)] = mine[pi].url;
          }
          item.properties['Made from'] = mine.length === photos.length
            ? 'the same photos as the main item on this order'
            : 'photo ' + mine.map(function (p) { return photos.indexOf(p) + 1; }).join(' & ')
              + ' from the main item on this order';
        }
        items.push(item);
      });
    }
    // A second bag design: the same pets on another bag, so it needs the same
    // photos attached to its own line — whoever picks it up must not have to
    // hunt back through the order for them.
    var bd = bagDesigns();
    if (bd) {
      bd.items().forEach(function (item) {
        if (item.reusesOrderPhotos) {
          delete item.reusesOrderPhotos;
          for (var qi = 0; qi < photos.length; qi++) {
            item.properties['YOUR PHOTO_' + (qi + 1)] = photos[qi].url;
          }
          item.properties['Made from'] = 'the same photos as the main item on this order';
        }
        items.push(item);
      });
    }
    return { items: items };
  }

  /* oneBag payload — properties are v4: written for the person FULFILLING
     the order, self-explanatory at a glance:
       Pets: 2 / Bag colour: Purple /
       Includes: 1 tote + 2 pet dolls + 2 names embroidered /
       Pet 1: Luna / Pet 2: Denny / Twin set: YES ... / Wings & Halo: Pet 1 ...
     Twin = SAME variant at quantity 2 (automatic BXGY discount prices the
     2nd set 30% off at checkout). */
  function buildOneBagItems(ctx) {
    // The LIVE checkbox is the source of truth at submit (same rule as the
    // notes textarea): a swallowed change event can never desync the cart
    // from what the customer sees ticked on the twin panel.
    var twinEl = ctx.root.querySelector('.personalizer__twin-input');
    if (twinEl) ctx.state.twin = twinEl.checked;
    var ot = ctx.state.orderType || 'full';
    var besties = ctx.state.besties;
    var n = besties.length;
    var unit = ctx.config.unitLabel || 'Bestie';
    var unitLc = unit.toLowerCase();
    var bagColor = besties[0] && besties[0].color;
    if (ot !== 'charm' && !bagColor) return { error: 'Please pick a bag colour.' };

    var variant = oneBagComboVariant(ctx.config, ot, n, false);
    if (!variant) return { error: 'This combination is unavailable — please adjust your picks.' };
    if (!variant.available) return { error: 'This combination is sold out — please adjust your picks.' };

    var built = oneBagProps(ctx, ot, bagColor);
    if (built.error) return { error: built.error };
    var props = built.props;
    if (ctx.state.twin) props['Twin set'] = 'YES — everything ×2, 2nd set 20% off';

    return finishItems(ctx, props, variant, ctx.state.twin ? 2 : 1, 'v4');
  }

  /* Besties-style properties for ONE bag, one line per pet saying exactly what
     it gets:
       Pets: 2 / Bag colour: Blue /
       Pet 1: nana — doll + name embroidered / Pet 2: papa — ...
     Shared with the second-design offer, which puts the same pets on another
     bag in another colour: two lines describing the same work must describe it
     the same way, or fulfillment reads one order two ways. */
  function oneBagProps(ctx, ot, bagColor) {
    var besties = ctx.state.besties;
    var n = besties.length;
    var unit = ctx.config.unitLabel || 'Bestie';
    var unitLc = unit.toLowerCase();
    var props = {};
    props[unit + 's'] = String(n);
    if (ot !== 'charm') props['Bag colour'] = bagColor;
    // What each pet gets. On a bag whose embroidery is ONE line for the whole
    // piece, saying "name embroidered" per pet would tell the workshop to
    // stitch something nobody ordered.
    var oneLine = !!(ctx.config.nameField && ctx.config.nameField.single);
    var what = ot === 'full' ? (oneLine ? 'crochet doll' : 'doll + name embroidered')
      : ot === 'tote' ? (oneLine ? 'no doll — words embroidered on the bag' : 'design + name embroidered (no doll)')
        : 'doll charm';
    var xf = ctx.config.extraField;
    var nf = ctx.config.nameField;
    // Some bags carry ONE line for the whole piece rather than a name per pet
    // (nameField.single — a quote the customer writes). Asking those orders for
    // a name per pet blocks the cart over a field the page never showed.
    var singleName = !!(nf && nf.single);
    if (singleName && ot !== 'charm') {
      var line = String(ctx.state.orderName || '').trim().slice(0, nf.max || 40);
      if (!line && nf.required) {
        return { error: 'Please type the words for the bag — that is what we embroider.' };
      }
      if (line) props[nf.label || 'Embroidered words'] = line;
    }
    for (var j = 0; j < n; j++) {
      var nm = String(besties[j].petName || '').trim().slice(0, 40);
      if (!nm && !singleName && ot !== 'charm' && nf && nf.required) {
        return { error: 'Please type every ' + unitLc + "'s name — we embroider it on the bag." };
      }
      props[unit + ' ' + (j + 1)] = (nm ? nm + ' — ' : '') + what;
      // optional companion value per unit (e.g. the EST. year on a varsity arch)
      if (xf && ot !== 'charm') {
        var xv = String(besties[j].petExtra || '').trim().slice(0, 12);
        if (!xv && xf.required) {
          return { error: 'Please fill in the ' + String(xf.label || 'extra field').toLowerCase() + ' for every ' + unitLc + '.' };
        }
        if (xv) props[(xf.propertyLabel || 'Extra') + ' ' + (j + 1)] = xv;
      }
    }
    return { props: props };
  }

  /* "count" payload (nursery mobiles): the count variant + v4 properties.
     Pet names are optional here (nothing embroidered) — included when typed
     so fulfillment can match photos to pets. */
  function buildCountItems(ctx) {
    var n = ctx.state.besties.length;
    var unit = ctx.config.unitLabel || 'Pet';
    var variant = countVariant(ctx.config, n, ctx.state.axis);
    if (!variant) return { error: 'This combination is unavailable — please adjust your picks.' };
    if (!variant.available) return { error: 'This option is sold out — please adjust your picks.' };
    var props = {};
    props[unit + 's'] = String(n);
    // What the customer is getting, in the words of THIS product: a hoop order
    // that calls itself a mobile confuses whoever packs it. Default keeps the
    // nursery mobiles' existing wording untouched.
    var includes = ctx.config.includesTemplate || '1 nursery mobile + {n} crochet {unit} doll{s}';
    // every occurrence: the memorial template pluralises both the dolls and
    // their cards ("{unit}{s} + their photo card{s}")
    props['Includes'] = includes
      .split('{n}').join(n)
      .split('{unit}').join(unit.toLowerCase())
      .split('{s}').join(n > 1 ? 's' : '');
    // two or more dolls: the answer to "same person?" — the workshop must not guess
    if (ctx.config.sameSubject && n >= 2 && typeof ctx.state.sameSubject === 'boolean') {
      props['Same person'] = ctx.state.sameSubject
        ? 'Yes — ' + n + ' ' + unit.toLowerCase() + 's of one person'
        : 'No — ' + n + ' different people';
    }
    // different people: which of the YOUR PHOTO_k lines belong to which doll
    // (the photos are written in doll order by finishItems)
    var byUnit = ctx.photoGroup() && ctx.photoGroup().getPhotosByUnit ? ctx.photoGroup().getPhotosByUnit() : null;
    if (byUnit) {
      var at = 0;
      byUnit.forEach(function (arr, i) {
        if (!arr.length) return;
        props[unit + ' ' + (i + 1) + ' photos'] = arr.length === 1
          ? '#' + (at + 1)
          : '#' + (at + 1) + '–#' + (at + arr.length);
        at += arr.length;
      });
    }
    // the second product option (frame) belongs on the order line too
    if (ctx.state.axis && ctx.config.countAxis) props[ctx.config.countAxis.label || 'Option'] = ctx.state.axis;
    var nf = ctx.config.nameField;
    if (nf && nf.single) {
      // one embroidery line for the whole piece, written by the customer
      var line = String(ctx.state.orderName || '').trim().slice(0, nf.max || 40);
      if (line) props[nf.label || 'Embroidered name'] = line;
    } else {
      // per-unit card lines (memorial dolls): name and the optional companion
      // value (config.extraField — the dates). Both may be blank; only what
      // the customer typed reaches the order, so nothing is printed unasked.
      var cxf = ctx.config.extraField;
      for (var i = 0; i < n; i++) {
        var nm = String(ctx.state.besties[i].petName || '').trim().slice(0, 40);
        if (nm) props[unit + ' ' + (i + 1)] = nm;
        if (cxf) {
          var cxv = String(ctx.state.besties[i].petExtra || '').trim().slice(0, cxf.max || 12);
          if (cxv) props[(cxf.propertyLabel || 'Extra') + ' ' + (i + 1)] = cxv;
        }
      }
    }
    return finishItems(ctx, props, variant, 1, 'v4');
  }

  /* An accepted companion offer (personalizer-crosssell.js) rides the same
     bar: its discounted price joins the total, its full price joins the strike
     so the saving stays visible even on products that strike nothing. */
  function cross() { return window.PersonalizerCross || null; }

  /* A second bag design (personalizer-bag-designs.js) rides the bar the same
     way — discounted price into the total, full price into the strike. */
  function bagDesigns() { return window.PersonalizerBagDesigns || null; }

  function addOnCents(fn) {
    var total = 0;
    [cross(), bagDesigns()].forEach(function (m) { if (m) total += m[fn](); });
    return total;
  }

  function totalCents(ctx) {
    return baseTotalCents(ctx) + addOnCents('cents');
  }

  function compareTotalCents(ctx) {
    var base = baseCompareCents(ctx);
    var extra = addOnCents('compareCents');
    if (!extra) return base;
    return (base || baseTotalCents(ctx)) + extra;
  }

  /* Payload per CONTRACT v3. Returns { items } or { error } — never throws. */
  function buildItems(ctx) {
    if (ctx.config.bagMode === 'count') return buildCountItems(ctx);
    if (ctx.config.bagMode === 'oneBag') return buildOneBagItems(ctx);
    var besties = ctx.state.besties;
    var n = besties.length;
    var unitWord = (ctx.config.unitLabel || 'bestie').toLowerCase();
    var props = { 'Besties': String(n) };
    for (var i = 0; i < n; i++) {
      var def = typeDef(ctx.config, besties[i].type);
      if (!def || (def.needsColor && !besties[i].color)) {
        return { error: 'Please pick a type (and colour) for every ' + unitWord + '.' };
      }
      var meta = COMBO_TYPES[besties[i].type];
      var display = meta ? meta.display : def.label;
      // Property KEY stays "Bestie i" for every product — fulfillment contract
      // (NECOM BASE export parses these keys); unitLabel only changes the UI.
      props['Bestie ' + (i + 1)] = def.needsColor ? display + ' · ' + besties[i].color : display;
    }
    // Embroidered-name products (config.nameField set): one name per unit,
    // ADDITIVE properties ("Pet name 1") — the v3 key contract is untouched.
    if (ctx.config.nameField) {
      var nameKey = (ctx.config.unitLabel || 'Bestie') + ' name ';
      for (var j = 0; j < n; j++) {
        var nm = String(besties[j].petName || '').trim().slice(0, 40);
        if (!nm && ctx.config.nameField.required) {
          return { error: 'Please type every ' + unitWord + "'s name — we embroider it on the bag." };
        }
        if (nm) props[nameKey + (j + 1)] = nm;
      }
    }
    var variant = comboVariantFor(ctx.config, besties);
    if (!variant) return { error: 'This combination is unavailable — please adjust your picks.' };
    if (!variant.available) return { error: 'This combination is sold out — please adjust your picks.' };

    return finishItems(ctx, props, variant);
  }

  /* Single POST to /cart/add.js, then redirect to the cart (mirrors the store's
     "add_and_redirect" setting). 422/network errors surface a friendly inline
     message and keep all state. Fulfillment locates the personalized line by
     "_personalizer": "v3" — Shopify's batch add gives no ordering guarantee. */
  function submitToCart(ctx) {
    var errorEl = ctx.root.querySelector('[data-personalizer-form-error]');
    var submitBtn = ctx.root.querySelector('[data-personalizer-submit]');
    var spinner = ctx.root.querySelector('[data-personalizer-spinner]');
    errorEl.hidden = true;

    var payload = buildItems(ctx);
    if (payload.error) {
      errorEl.textContent = payload.error;
      errorEl.hidden = false;
      return;
    }

    submitBtn.disabled = true;
    spinner.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: payload.items })
    }).then(function (res) {
      if (res.ok) {
        try { sessionStorage.removeItem(ctx.storageKey); } catch (err) { /* non-fatal */ }
        window.location = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
        return null;
      }
      // Error bodies are not guaranteed to be JSON (proxy/CDN HTML pages, bot
      // challenges) — a parse failure must surface a friendly message.
      return res.json().catch(function () { return null; }).then(function (body) {
        throw new Error((body && (body.description || body.message)) || 'Could not add to cart. Please try again.');
      });
    }).catch(function (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
      submitBtn.disabled = false;
      spinner.hidden = true;
    });
  }

  window.PersonalizerCart = {
    formatMoney: formatMoney,
    typeDef: typeDef,
    comboVariantFor: comboVariantFor,
    oneBagComboVariant: oneBagComboVariant,
    oneBagProps: oneBagProps,
    countVariant: countVariant,
    axisValues: axisValues,
    typePriceCents: typePriceCents,
    totalCents: totalCents,
    compareTotalCents: compareTotalCents,
    buildItems: buildItems,
    submitToCart: submitToCart
  };
})();
